import { useLocation, useParams } from 'react-router'
import { ComponentWithPermissions } from '../../../../../../../baseComponents/CreateRoutering/types'
import EditCardTabs from '../../../../../../../baseComponents/EditCardTabs'
import { getBasePath } from '../../../../../../../utils/globals/link'
import { useBasicData } from '../../../../../../../utils/hooks/useBasicData'
import { ComponentTabObject } from '../../../../../../../utils/hooks/useTabLogic'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import MainWorkingCenterConnect from './Tabs/MainWorkingCenter'
import WorkingCenterEmployees from './Tabs/WorkingCenterEmployees'
import WorkingCenterTasks from './Tabs/WorkingCenterTasks'
import CountersWorkingCenter from './Tabs/CountersWorkingCenter'
import WarehousesWorkingCenter from './Tabs/WarehousesWorkingCenter'
import ShippingServicesWorkingCenter from './Tabs/ShippingServicesWorkingCenter'
import WorkingCenterBanks from './Tabs/WorkingCenterBanks'
import WorkingCenterStations from './Tabs/WorkingCenterStations'
import WorkingCenterUsers from './Tabs/WorkingCenterUsers'
import WorkingCenterShift4Devices from './Tabs/WorkingCenterShift4Devices'
import { useMemo } from 'react'
import { getConfigParam } from '../../../../../../../utils/reducers/getters'



type SingleWorkingCenterProps = ComponentWithPermissions & {}

const SingleWorkingCenter: React.FC<SingleWorkingCenterProps> = ({ userPermissions }) => {
    const location = useLocation()
    const params = useParams<{ id: string, tab?: string }>()
    const { t } = useTwinTranslation()
    const haveShift4Config = useMemo(() => getConfigParam('shift4CompanyName'), [])
    const { basicData, getData } = useBasicData({ params: {id: params.id}, url: '/api/app/workingCenter/getWorkingCenterComplete', variableToCurrentPage: 'name' })
    if (!params.id) {
        return null
    }
    const tabs: ComponentTabObject = {
        'main': { component: MainWorkingCenterConnect, text: t('general', 'General'), permission: 'workingCenter.main', },
        'employees': { component: WorkingCenterEmployees, text: t('employees', 'Empleados'), permission: 'workingCenter.employee', },
        'tasks': { component: WorkingCenterTasks, text: t('tasks', 'Tareas'), permission: 'workingCenter.employee', modules: ['tasks']},
        'warehouses': { component: WarehousesWorkingCenter, text: t('warehouses', 'Almacenes'), permission: 'workingCenter.warehouse', },
        'shipping-services': { component: ShippingServicesWorkingCenter, text: t('shippingCompanies', 'Transportistas'), permission: 'workingCenter.shippingService', },
        'counters': { component: CountersWorkingCenter, text: t('counters', 'Contadores'), permission: 'workingCenter.counter', },
        'banks': { component: WorkingCenterBanks, text: t('banks', 'Bancos'), permission: 'workingCenter.bank', },
        'workStations': { component: WorkingCenterStations, text: t('workStations', 'Puestos'), permission: 'workingCenter.station' },
        'users': { component: WorkingCenterUsers, text: t('users', 'Usuarios'), permission: 'workingCenter.employee' },
        'shift4Devices': { component: WorkingCenterShift4Devices, text: t('shift4Devices', 'Dispositivos Shift4'), permission: 'workingCenter.shift4Device', hideTab: haveShift4Config ? false : true },
    }

    return (<EditCardTabs basePath={getBasePath(location.pathname, params.id)} basicData={basicData} tabs={tabs} tab={params.tab} userPermissions={userPermissions} getData={getData} />)
}

export default SingleWorkingCenter